/** The complimentary 15-minute session with an LTC Planning Expert, offered to consumers once they've paid to self-fund. */
export const LTC_PLANNING_SESSION_URL =
  'https://calendly.com/lori-joinwaterlily/waterlily-consumer-15-minute-walkthrough';

export const LTC_PLANNING_SESSION_LABEL = 'Book your free 15-min session';
